import {
  // global settings imports
  GET_PAGE_ITEM_OPERATIONS,
  GET_PAGE_ITEM_OPERATIONS_SUCCESS,
  GET_PAGE_ITEM_OPERATIONS_FAIL,
  GET_ALERT_LISTING_COLUMN_NAMES,
  GET_ALERT_LISTING_COLUMN_NAMES_SUCCESS,
  GET_ALERT_LISTING_COLUMN_NAMES_FAIL,
  GET_ALERT_DETAILS_COLUMN_NAMES,
  GET_ALERT_DETAILS_COLUMN_NAMES_SUCCESS,
  GET_ALERT_DETAILS_COLUMN_NAMES_FAIL,
  GET_TM_ALERTS_LISTING_SETTINGS,
  GET_TM_ALERTS_LISTING_SETTINGS_SUCCESS,
  GET_TM_ALERTS_LISTING_SETTINGS_FAIL,
  PUT_TM_ALERTS_LISTING_SETTINGS,
  PUT_TM_ALERTS_LISTING_SETTINGS_SUCCESS,
  PUT_TM_ALERTS_LISTING_SETTINGS_FAIL,
  GET_GLOBAL_SETTINGS_PAGE_INFO,
  GET_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
  GET_GLOBAL_SETTINGS_PAGE_INFO_FAIL,
  GET_NS_GLOBAL_SETTINGS_PAGE_INFO,
  GET_NS_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
  GET_NS_GLOBAL_SETTINGS_PAGE_INFO_FAIL,
  PUT_GLOBAL_SETTINGS_WIDGET_GROUP,
  PUT_GLOBAL_SETTINGS_WIDGET_GROUP_SUCCESS,
  PUT_GLOBAL_SETTINGS_WIDGET_GROUP_FAIL,
  PUT_GLOBAL_SETTINGS_WIDGETS,
  PUT_GLOBAL_SETTINGS_WIDGETS_SUCCESS,
  PUT_GLOBAL_SETTINGS_WIDGETS_FAIL,
  PUT_GLOBAL_SETTINGS_WIDGET_INFO,
  PUT_GLOBAL_SETTINGS_WIDGET_INFO_SUCCESS,
  PUT_GLOBAL_SETTINGS_WIDGET_INFO_FAIL,
  GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO,
  GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
  GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_FAIL,

  // create run instance imports
  GET_CATEGORIES_CREATE_RUN_INSTANCE,
  GET_CATEGORIES_CREATE_RUN_INSTANCE_SUCCESS,
  GET_CATEGORIES_CREATE_RUN_INSTANCE_FAIL,
  POST_SEGMENT_SETS_RUN_INSTANCE,
  POST_SEGMENT_SETS_RUN_INSTANCE_SUCCESS,
  POST_SEGMENT_SETS_RUN_INSTANCE_FAIL,
  GET_LIVE_SETS_RUN_INSTANCE,
  GET_LIVE_SETS_RUN_INSTANCE_SUCCESS,
  GET_LIVE_SETS_RUN_INSTANCE_FAIL
} from '../actions/settings';

export const initialState = {
  alertColumns: { isLoading: false, data: null, error: null },
  alertDetailColumns: { isLoading: false, data: null, error: null },
  configuration: { isLoading: false, data: null, error: null, isSaved: false },
  nsSetting: { isLoading: true, error: null, data: null },
  amlsCommonSetting: {
    isLoading: true,
    error: null,
    data: null,
    isSaved: false
  },
  createRunInstanceCategories: { isLoading: false, data: null, error: null },
  createRunInstanceLiveSets: { isLoading: false, data: null, error: null },
  postSegmentSets: { isLoading: false, showSuccessMsg: false, errorMsg: null }
};

function settings(state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORIES_CREATE_RUN_INSTANCE:
      return {
        ...state,
        createRunInstanceCategories: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_CATEGORIES_CREATE_RUN_INSTANCE_SUCCESS:
      return {
        ...state,
        createRunInstanceCategories: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_CATEGORIES_CREATE_RUN_INSTANCE_FAIL:
      return {
        ...state,
        createRunInstanceCategories: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case POST_SEGMENT_SETS_RUN_INSTANCE:
      return {
        ...state,
        postSegmentSets: {
          isLoading: true,
          errorMsg: null,
          showSuccessMsg: false
        }
      };
    case POST_SEGMENT_SETS_RUN_INSTANCE_SUCCESS:
      return {
        ...state,
        postSegmentSets: {
          isLoading: false,
          errorMsg: null,
          showSuccessMsg: true
        }
      };
    case POST_SEGMENT_SETS_RUN_INSTANCE_FAIL:
      return {
        ...state,
        postSegmentSets: {
          isLoading: false,
          errorMsg: action.payload
        }
      };

    case GET_LIVE_SETS_RUN_INSTANCE:
      return {
        ...state,
        createRunInstanceLiveSets: {
          isLoading: true,
          error: null,
          data: null
        },
        postSegmentSets: {
          ...state.postSegmentSets,
          showSuccessMsg: false
        }
      };
    case GET_LIVE_SETS_RUN_INSTANCE_SUCCESS:
      return {
        ...state,
        createRunInstanceLiveSets: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_LIVE_SETS_RUN_INSTANCE_FAIL:
      return {
        ...state,
        createRunInstanceLiveSets: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    // global settings cases
    case GET_PAGE_ITEM_OPERATIONS:
      return {
        ...state,
        widgetItemOperations: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_PAGE_ITEM_OPERATIONS_SUCCESS:
      return {
        ...state,
        widgetItemOperations: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_PAGE_ITEM_OPERATIONS_FAIL:
      return {
        ...state,
        widgetItemOperations: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_ALERT_LISTING_COLUMN_NAMES:
      return {
        ...state,
        alertColumns: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_ALERT_LISTING_COLUMN_NAMES_SUCCESS:
      return {
        ...state,
        alertColumns: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_ALERT_LISTING_COLUMN_NAMES_FAIL:
      return {
        ...state,
        alertColumns: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_ALERT_DETAILS_COLUMN_NAMES:
      return {
        ...state,
        alertDetailColumns: {
          isLoading: true,
          error: null,
          data: null
        }
      };
    case GET_ALERT_DETAILS_COLUMN_NAMES_SUCCESS:
      return {
        ...state,
        alertDetailColumns: {
          isLoading: false,
          error: null,
          data: {
            ...action.payload
          }
        }
      };
    case GET_ALERT_DETAILS_COLUMN_NAMES_FAIL:
      return {
        ...state,
        alertDetailColumns: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_TM_ALERTS_LISTING_SETTINGS:
      return {
        ...state,
        configuration: {
          isLoading: true,
          error: null,
          data: null,
          isSaved: false
        }
      };
    case GET_TM_ALERTS_LISTING_SETTINGS_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: {
            ...action.payload
          }
        }
      };
    case GET_TM_ALERTS_LISTING_SETTINGS_FAIL:
      return {
        ...state,
        configuration: {
          isLoading: false,
          data: null,
          isSaved: false,
          error: {
            ...action.payload
          }
        }
      };

    case PUT_TM_ALERTS_LISTING_SETTINGS:
      return {
        ...state,
        configuration: {
          isLoading: true,
          error: null,
          data: null,
          isSaved: false
        }
      };
    case PUT_TM_ALERTS_LISTING_SETTINGS_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: true,
          data: null
        }
      };
    case PUT_TM_ALERTS_LISTING_SETTINGS_FAIL:
      return {
        ...state,
        configuration: {
          isLoading: false,
          data: null,
          isSaved: false,
          error: {
            ...action.payload
          }
        }
      };
    //phase 3
    case GET_GLOBAL_SETTINGS_PAGE_INFO:
      return {
        ...state,
        configuration: {
          isLoading: true,
          error: null,
          data: null,
          isSaved: false
        }
      };
    case GET_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: {
            ...action.payload
          }
        }
      };
    case GET_GLOBAL_SETTINGS_PAGE_INFO_FAIL:
      return {
        ...state,
        configuration: {
          isLoading: false,
          data: null,
          isSaved: false,
          error: {
            ...action.payload
          }
        }
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_GROUP:
      return {
        ...state
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_GROUP_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: null
        }
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_GROUP_FAIL:
      return {
        ...state
      };
    case PUT_GLOBAL_SETTINGS_WIDGETS:
      return {
        ...state
      };
    case PUT_GLOBAL_SETTINGS_WIDGETS_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: null
        }
      };
    case PUT_GLOBAL_SETTINGS_WIDGETS_FAIL:
      return {
        ...state
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_INFO:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: null
        }
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_INFO_SUCCESS:
      return {
        ...state,
        configuration: {
          isLoading: false,
          error: null,
          isSaved: true,
          data: null
        }
      };
    case PUT_GLOBAL_SETTINGS_WIDGET_INFO_FAIL:
      return {
        ...state
      };
    case GET_NS_GLOBAL_SETTINGS_PAGE_INFO:
      return {
        ...state,
        nsSetting: { isLoading: true, error: null, data: state.nsSetting.data }
      };
    case GET_NS_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS:
      return {
        ...state,
        nsSetting: { isLoading: false, data: action.payload, error: null }
      };
    case GET_NS_GLOBAL_SETTINGS_PAGE_INFO_FAIL:
      return {
        ...state,
        nsSetting: { isLoading: false, data: null, error: action.payload }
      };
    case GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO:
      return {
        ...state,
        amlsCommonSetting: {
          ...initialState.amlsCommonSetting,
          ...state.amlsCommonSetting
        }
      };
    case GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS:
      return {
        ...state,
        amlsCommonSetting: {
          isLoading: false,
          error: null,
          isSaved: false,
          data: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_FAIL:
      return {
        ...state,
        amlsCommonSetting: {
          isLoading: false,
          data: null,
          isSaved: false,
          error: {
            ...action.payload
          }
        }
      };

    default:
      return state;
  }
}

export default settings;
